export const ROUTES = {
    account: "account",
};
